import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { key: String }

  connect () {
    if (this.keyValue && localStorage.getItem(this.keyValue)) {
      this.element.remove()
      return
    }
    requestAnimationFrame(() => {
      this.element.classList.remove('opacity-0', 'translate-y-1')
    })
  }

  dismiss () {
    if (this.keyValue) localStorage.setItem(this.keyValue, '1')
    this.element.classList.add('opacity-0', 'translate-y-1')
    setTimeout(() => this.element.remove(), 250)
  }
}
